import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

import AnimatedRoute from "./AnimatedRoute";

import { getRouteMetaDescription, getRouteTitle } from "functions/getMeta";
import { useLocation } from "react-router-dom";

import routes from "configs/routes";

import auth from "functions/auth";

const og = "/uploads/og/og.jpg";

const CustomRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const componentName = rest.componentName;
  const title = getRouteTitle(
    rest.path,
    true
  ); /* + ( rest.path === routes.apartment ? ` - ${ rest.location.pathname.split("/")[2] }` : "" ) */
  const metaDescription = getRouteMetaDescription(rest.path);
  const _protected = rest.protected ? rest.protected : false;

  return (
    <>
      {!_protected && (
        <Route
          {...rest}
          render={(props) => {
            return (
              <>
                <Helmet>
                  <title>{title}</title>
                  <meta name="description" content={metaDescription} />

                  <meta
                    property="og:url"
                    content={`https://csango10.hu${location.pathname}`}
                  />
                  <meta property="og:type" content="website" />
                  <meta property="og:title" content={title} />
                  <meta property="og:description" content={metaDescription} />
                  <meta
                    property="og:image"
                    content={`https://csango10.hu${og}`}
                  />

                  <meta name="twitter:card" content="summary_large_image" />
                  <meta property="twitter:domain" content="csango10.hu/" />
                  <meta
                    property="twitter:url"
                    content={`https://csango10.hu${location.pathname}`}
                  />
                  <meta name="twitter:title" content={title} />
                  <meta name="twitter:description" content={metaDescription} />
                  <meta
                    name="twitter:image"
                    content={`https://csango10.hu${og}`}
                  />
                </Helmet>

                <AnimatedRoute className={componentName}>
                  <Component {...props} />
                </AnimatedRoute>
              </>
            );
          }}
        />
      )}
      {_protected && (
        <Route
          {...rest}
          render={(props) => {
            if (auth.isAuthenticated()) {
              //Autentikálva van
              return (
                <AnimatedRoute className={componentName}>
                  <Component {...props} />
                </AnimatedRoute>
              );
            } else {
              //Nincs autentikálva
              return (
                <Redirect
                  to={{
                    pathname: routes.login,
                    state: { from: props.location },
                  }}
                />
              );
            }
          }}
        />
      )}
    </>
  );
};

export default CustomRoute;
